<div class="page-container">
  <div class="bris-de-glace-label" *ngIf="isBrisDeGlace">BRIS DE GLACE</div>
  <div class="buttons-container margin-bottom">
    <frg-button (activated)="importDocument()" [disabled]="isEdit">
      <div title="Importer de nouveaux documents">Importer de nouveaux documents</div>
    </frg-button>
  </div>

  <ng-container *ngIf="patientDocumentsTable && patientDocumentsTable.objects && patientDocumentsTable.objects.length > 0">
    <div class="table-label">Documents patient</div>
    <frg-table
      [keysBody]="patientDocumentsTable"
      [keysColumn]="patientDocumentsTableColumnTable"
      [tableButton1]="'assets/icons/add-green.svg'"
      tableButton1Tooltip="Ajouter le document"
      (onClick1)="addToAddList($event)"
      (onChangePage)="onPatientDocsPageChange($event)"
      (onSort)="onPatientDocsSort($event)"
    ></frg-table>
  </ng-container>

  <div class="separator"></div>

  <ng-container *ngIf="documentsToAddTable && documentsToAddTable.objects && documentsToAddTable.objects.length > 0">
    <div class="table-label">Documents à ajouter au DMP</div>
    <frg-table
      id="docs-to-add-table"
      [keysBody]="documentsToAddTable"
      [keysColumn]="documentsToAddTableColumnTable"
      [tableButton1]="'assets/icons/minus-danger.svg'"
      tableButton1Tooltip="Retirer le document"
      (onClick1)="removeFromAddList($event)"
      [tableButton2]="'assets/icons/edit.svg'"
      tableButton2Tooltip="Modifier les informations du document"
      (onClick2)="openDocFormEdit($event)"
    ></frg-table>

    <div class="lot-form-container" *ngIf="documentsToAddTable.objects.length > 1">
      <frg-form-input
        id="lotTitle"
        label="Titre du lot"
        type="text"
        [formGroup]="formGroup"
        [control]="formGroup.get('lotTitle')"
      ></frg-form-input>

      <frg-form-input
        id="lotDescription"
        label="Commentaire du lot"
        type="textarea"
        [formGroup]="formGroup"
        [control]="formGroup.get('lotDescription')"
      ></frg-form-input>
    </div>
  </ng-container>

  <div class="buttons-container align-right margin-top">
    <frg-button (activated)="cancelAdd()" backgroundColor="var(--darkest-primary)">
      <div title="Annuler l'ajout">Annuler l'ajout</div>
    </frg-button>
    <frg-button (activated)="addDocumentsToDMP()" *ngIf="!isEdit && documentsToAddTable && documentsToAddTable.objects && documentsToAddTable.objects.length > 0">
      <div title="Envoyer le(s) document(s) dans le DMP">Envoyer le(s) document(s) dans le DMP</div>
    </frg-button>
  </div>
</div>